import { createContext, ReactNode, useContext, useMemo } from 'react';

import { Hello } from 'api/utility/utility.model';
import Loading from 'components/Icons/Loading';
import TechnicalBreak from 'components/TechnicalBreak';

import { useApiConnectionQuery } from '../hooks/useApiConnectionQuery';

export interface ApiConnectionContextProps {
  hello: Hello;
}

const defaultValues: ApiConnectionContextProps = {
  hello: '',
};

const ApiConnectionContext = createContext<ApiConnectionContextProps>(defaultValues);

export const useApiConnectionContext = () => useContext(ApiConnectionContext);

interface ApiConnectionContextProviderProps {
  children: ReactNode;
}

export function ApiConnectionContextProvider({ children }: ApiConnectionContextProviderProps) {
  const {
    data: hello,
    isLoading,
    error,
  } = useApiConnectionQuery({
    retry: 2,
    refetchOnWindowFocus: false,
  });

  const contextValue = useMemo(
    () => ({
      hello: hello as Hello,
    }),
    [hello]
  );

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <TechnicalBreak />;
  }

  return (
    <ApiConnectionContext.Provider value={contextValue}>{children}</ApiConnectionContext.Provider>
  );
}
